import React from 'react';
import CSVReader from 'react-csv-reader'
import {ManualData} from '../../components/manual-data-form/manual.data.form.component';
import chart  from "ascii-horizontal-barchart";
import {DropDown} from '../../components/dropdown/dropdown.component';
import {FIXED_CHAR} from '../../components/fixedchar';
import {InputType} from '../../components/input/input.component';


class HHistogram extends React.Component {
    constructor(){
          super();
          this.state = {
            data: { "ＵＳＡ": 33515308, "Ｉｎｄｉａ": 22992517, "Ｂｒａｚｉｌ": 15214030, "Ｆｒａｎｃｅ": 5780379 }, 
            dataType: "FileType",
            isManualError: false,
            graph:null,
          }
          this.createGraph();
       }
    strip = (str)=>{
        return str.replace(/^\s+|\s+$/g, '');
      }
    convertFixed = (str)=>{
        let tmp = "";
        for(let i=0; i<str.length; i++) {
          tmp+=FIXED_CHAR[str[i]];
        }
        return tmp;
      }
    handleDropDownChange = (dataType)=>{
        this.setState({dataType: dataType, data: {}})
      }
    handleCSVUpload = (data, _)=> {
        let chartData = {};
        for(let i=0; i<data[0].length; i+=1) {
          chartData[this.convertFixed(this.strip(data[0][i]))] = parseInt(data[1][i]);
        }
        this.setState({data: chartData})
      }
    isObjectEmpty(obj) {
        for(var key in obj) {
            if(obj.hasOwnProperty(key))
                return true;
        }
        return false;
    }
    handleInputChange = (event)=>{
       
      let data = event.target.value.split("\n");
      let currData = {}
      let currVal;
      for(let i=0; i<data.length; i++) {
        currVal = data[i].split(",")
        currData[this.convertFixed(this.strip(currVal[0]))] = parseInt(currVal[1]);
      }
      this.setState({data:currData});
      }
    createGraph = ()=>{
      let graph = chart(this.state.data, true, 10);
      this.setState({graph: graph});
    }
    componentDidMount() {
        this.createGraph();
    }
    render() {
        let dataEntryType = null, graph=null;
        dataEntryType = <div className="col-4"> <InputType type="text" id="inputValues" placeholder={"USA, 33515308\nIndia, 22992517\n Brazil,15214030\nFrance,5780379"} label="Values" name="values" handleInputChange={this.handleInputChange} />
            </div>
            
        
        return (
          <div className="container graph">
            <div className="row">
            <h3 className="col-2">Horizontal Histogram</h3>
            {dataEntryType}
            <div className="col-2"><button className="btn btn-primary " onClick={this.createGraph}>Get chart</button></div>
            {this.state.graph ? <pre className="col-3">{this.state.graph}</pre> :<p class="col-3">No data exists</p> } 

        </div>
        </div>);
    }
    
    }

export default HHistogram;
